// extracted by mini-css-extract-plugin
export default {"wrapper":"Hero_wrapper__Th53k","textWrapper":"Hero_textWrapper__Gn-Kl"};